export enum MuacLevel {

    LEVEL_1 = 'SD3-',
    LEVEL_2 = 'SD2-',
    LEVEL_3 = 'SD1-',
    LEVEL_4 = 'SD0',
    LEVEL_5 = 'SD1',
    LEVEL_6 = 'SD2',
    LEVEL_7 = 'SD3',
    SEVERE_ACUTE_MALNUTRITION = 'Desnutrición aguda severa',
    MODERATE_ACUTE_MALNUTRITION = 'Desnutrición aguda moderada',
    ACUTE_MALNUTRITION = 'Desnutrición aguda',
    RISK_OF_ACUTE_MALNUTRITION = 'Riesgo de desnutrición aguda',
    OUTSIDE_OF_RISK_ZONE = 'Niño fuera de la zona de riesgo',
    HEALED = 'Niño recuperado',
    NO_MEASURED = 'No Medido',
    UNKNOWN_LEVEL = 'none'

}
